export default {
  viewBox: [0, 0, 35, 35],
  shape:
    '<g><path d="M26.25 8.75L8.75 26.25" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M8.75 8.75L26.25 26.25" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></g>',
};
